import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useFormUtility from "../utilities/useFormUtility";
import useHttpUtility from "../utilities/useHttpUtility";
import useWindowUtility from "../utilities/useWindowUtility";
import RuleSection from "../sections/RuleSection";
import WindowSection from "../sections/WindowSection";
import MenuPageItemDiscard from "../components/MenuPageItemDiscard";
import MenuPageItemCopy from "../components/MenuPageItemCopy";
import MenuPageItemSave from "../components/MenuPageItemSave";
import MenuPageItemDelete from "../components/MenuPageItemDelete";
import LoadingScreen from "../components/LoadingScreen"
import MenuPage from "../components/MenuPage";
import FormFieldText from "../components/FormFieldText";
import FormFieldNumber from "../components/FormFieldNumber";
import FormFieldCheckbox from "../components/FormFieldCheckbox";
import FormFieldSelect from "../components/FormFieldSelect";
import Table from "../components/Table";
import Tabs from "../components/Tabs";
import Tab from "../components/Tab";
import ScheduleSelectionSection from "../sections/ScheduleSelectionSection";

export default function PageWindowsGroup() {

    const navigate = useNavigate();
    const http = useHttpUtility();

    const windowUtility = useWindowUtility();

    const { id } = useParams();
    
    const formUtility = useFormUtility(null);

    const [selectedIndexRule, setSelectedIndexRule] = useState(-1);
    const [selectedIndexWindow, setSelectedIndexWindow] = useState(-1);
    const [schedule, setSchedule] = useState(null);
    
    useEffect(() => {
        if (!id || id === "0") {
            formUtility.setData({
                id: null,
                groupType: "1",
                name: "",
                active: false,
                limitMode: "1",
                limit: "0",
                maxDays: "30",
                dateAttributes: "",
                dateAttributeOffset: "0",
                rules: [],
                windows: []
            }, true);
        }
        else {
            http.get(
                `/api/Windows/Groups/${id}`,
                (d) => formUtility.setData({
                    ...d,
                    groupType: d.groupType.toString(),
                    limitMode: d.limitMode.toString()
                })
            );
        }
    }, []);

    async function handleSave() {

        let limit = formUtility.data.limit?.toString()?.trim().length < 1 ? 0 : parseInt(formUtility.data.limit);
        let maxDays = formUtility.data.maxDays?.toString()?.trim().length < 1 ? 0 : parseInt(formUtility.data.maxDays);
        let dateAttributeOffset = formUtility.data.dateAttributeOffset?.toString()?.trim().length < 1 ? 0 : parseInt(formUtility.data.dateAttributeOffset);

        if (isNaN(limit) || limit < 0)
            return formUtility.showNotification(2, "Invalid rate limit.");

        if (isNaN(maxDays) || maxDays < 0)
            return formUtility.showNotification(2, "Invalid max days.");

        if (isNaN(dateAttributeOffset) || dateAttributeOffset < 0)
            return formUtility.showNotification(2, "Invalid date attribute offset.");

        let newData = {
            ...formUtility.data,
            limit: limit,
            maxDays: maxDays,
            dateAttributeOffset: dateAttributeOffset,
            windows: formUtility.data.windows.map(w => ({ ...w, rateId: !w.rateId || w.rateId === "0" || formUtility.data.groupType === "2" ? null : w.rateId }))
        };

        await http.post(
            `/api/Windows/Groups/${newData.id ? "Update" : "Create"}`,
            newData,
            formUtility.setData
        );
    }

    return (
        !formUtility.data
            ? <LoadingScreen />
            : 
                <div className="page page-windows-group">
                    {
                        selectedIndexRule >= 0 || selectedIndexRule === -2
                            ? <RuleSection
                                data={selectedIndexRule === -2 ? null : formUtility.data.rules[selectedIndexRule]}
                                isPickup={formUtility.data.groupType === "3"}
                                onDiscard={() => setSelectedIndexRule(-1)}
                                onOk={(x) => {
                                    if (selectedIndexRule < 0 && selectedIndexRule !== -2)
                                        return;

                                    let items = [...formUtility.data.rules];

                                    selectedIndexRule >= 0
                                        ? items.splice(selectedIndexRule, 1, x)
                                        : items.push(x);

                                    formUtility.handleChange([{ field: "rules", value: items }]);
                                    setSelectedIndexRule(-1);
                            }} />
                        : selectedIndexWindow === -2 && !schedule
                            ? <ScheduleSelectionSection
                                onOk={setSchedule}
                                onDiscard={() => setSelectedIndexWindow(-1)} />
                        : selectedIndexWindow >= 0 || selectedIndexWindow === -2 || selectedIndexWindow === -3
                            ? <WindowSection
                                groupType={parseInt(formUtility.data.groupType)}
                                data={selectedIndexWindow < 0 ? null : formUtility.data.windows[selectedIndexWindow]}
                                schedule={schedule}
                                isPickup={formUtility.data.groupType === "3"}
                                onDiscard={() => {
                                    setSelectedIndexWindow(-1);
                                    setSchedule(null);
                                }}
                                onOk={(x) => {
                                    if (selectedIndexWindow < 0 && selectedIndexWindow !== -2 && selectedIndexWindow !== -3)
                                        return;

                                    let items = [...formUtility.data.windows];

                                    selectedIndexWindow >= 0
                                        ? items.splice(selectedIndexWindow, 1, x)
                                        : items.push(x);

                                    formUtility.handleChange([{ field: "windows", value: items }]);
                                    setSelectedIndexWindow(-1);
                                    setSchedule(null);
                                }} />
                        :
                            <>
                                <MenuPage>
                                    <MenuPageItemDiscard formUtility={formUtility} onClick={() => navigate(`..${window.location.search}`)} />
                                    <MenuPageItemCopy formUtility={formUtility} onClick={() => {
                                        var newData = {
                                            ...formUtility.data,
                                            id: null,
                                            name: "",
                                            active: false,
                                            rules: formUtility.data.rules.map(r => ({ ...r, id: null })),
                                            windows: formUtility.data.windows.map(w => ({ ...w, id: null }))
                                        };
                                        formUtility.setData(newData, true);
                                    }} />
                                    <MenuPageItemSave formUtility={formUtility} onClick={handleSave} />
                                    <MenuPageItemDelete formUtility={formUtility} onClick={() => http.delete(`/api/Windows/Groups/${formUtility.data.id}`, () => navigate(`..${window.location.search}`))} />
                                </MenuPage>
                                <FormFieldSelect
                                    formUtility={formUtility}
                                    field="groupType"
                                    label="Group Type"
                                    disabled={formUtility.data.id || formUtility.data.rules.length > 0 || formUtility.data.windows.length > 0}
                                    options={windowUtility.groupTypes}
                                    description={
                                        formUtility.data.groupType === "1" ? "Allows you to setup checkout rates based on delivery windows which is then shown to the user for selection at checkout."
                                        : formUtility.data.groupType === "2" ? "Allows you to create booking windows if you are using Shopify rates, third-party rates, or standard rates from Urgent Couriers.  Also useful for subscriptions and manual orders."
                                        : "Allows you to create date based pickup windows.  Disabling Shopify pickup functionality is required."
                                    } />
                                <FormFieldText formUtility={formUtility} field="name" label="Name" max="30" description="Name for the group for internal use." />
                                <FormFieldText formUtility={formUtility} field="description" label="Description (Optional)" max="250" />
                                <FormFieldCheckbox formUtility={formUtility} field="active" label="Active" description="Allows you to enable or disable the windows group as required." />
                                <br />
                                <h2>Rules</h2>
                                <p>Allows you to set up user defined rules which will define whether or not this windows group will be used.</p>
                                <Table
                                    formUtility={formUtility}
                                    data={formUtility.data.rules}
                                    mappings={
                                        [
                                            {
                                                header: "Type",
                                                field: "ruleType",
                                                dataType: "ruleType"
                                            },
                                            {
                                                header: "Condition",
                                                field: "condition",
                                                dataType: "condition"
                                            },
                                            {
                                                header: "Value",
                                                field: "value"
                                            },
                                            {
                                                header: "Or Group",
                                                field: "orGroup"
                                            }
                                        ]
                                    }
                                    onClickAdd={() => setSelectedIndexRule(-2)}
                                    onClick={setSelectedIndexRule}
                                    onRemove={(idx) => {
                                        if (idx < 0)
                                            return;

                                        let rules = [...formUtility.data.rules];
                                        rules.splice(idx, 1);
                                        formUtility.handleChange([{ field: "rules", value: rules }]);
                                    }}
                                />
                                <br />
                                <h2>{formUtility.data.groupType === "3" ? "Pickup Windows" : "Delivery Windows"}</h2>
                                <Tabs defaultTabName={formUtility.data.groupType === "3" ? "other" : "urgent"} >
                                    <Tab name="urgent" title="Urgent Couriers" hide={formUtility.data.groupType === "3"}>
                                        <Table
                                            formUtility={formUtility}
                                            mappings={
                                                [
                                                    {
                                                        header: "Name",
                                                        field: "name"
                                                    },
                                                    {
                                                        header: "Depot",
                                                        field: "depot"
                                                    },
                                                    {
                                                        header: "Service",
                                                        field: "service"
                                                    },
                                                    {
                                                        header: "Day of Week",
                                                        field: "dayOfWeek",
                                                        dataType: "dayOfWeek"
                                                    },
                                                    {
                                                        header: "Start Time",
                                                        field: "startTime"
                                                    },
                                                    {
                                                        header: "End Time",
                                                        field: "endTime"
                                                    }
                                                ]
                                            }
                                            data={formUtility.data.windows}
                                            filter={w => w.scheduleId}
                                            onClickAdd={() => setSelectedIndexWindow(-2)}
                                            onClick={setSelectedIndexWindow}
                                            onRemove={(idx) => {
                                                if (idx < 0)
                                                    return;

                                                let windows = [...formUtility.data.windows];
                                                windows.splice(idx, 1);
                                                formUtility.handleChange([{ field: "windows", value: windows }]);
                                            }}
                                        />
                                    </Tab>
                                    <Tab name="other" title={formUtility.data.groupType === "3" ? "Pickup" : "Other"}>
                                        <Table
                                            formUtility={formUtility}
                                            mappings={
                                                [
                                                    {
                                                        header: "Name",
                                                        field: "name"
                                                    },
                                                    {
                                                        header: "Day of Week",
                                                        field: "dayOfWeek",
                                                        dataType: "dayOfWeek"
                                                    },
                                                    {
                                                        header: "Start Time",
                                                        field: "startTime"
                                                    },
                                                    {
                                                        header: "End Time",
                                                        field: "endTime"
                                                    }
                                                ]
                                            }
                                            data={formUtility.data.windows}
                                            filter={w => !w.scheduleId}
                                            onClickAdd={() => setSelectedIndexWindow(-3)}
                                            onClick={setSelectedIndexWindow}
                                            onRemove={(idx) => {
                                                if (idx < 0)
                                                    return;

                                                let windows = [...formUtility.data.windows];
                                                windows.splice(idx, 1);
                                                formUtility.handleChange([{ field: "windows", value: windows }]);
                                            }}
                                        />
                                    </Tab>
                                </Tabs>
                                {
                                    formUtility.data.groupType !== "2"
                                    ? 
                                        <div className="page-section">
                                            <h2>Limits</h2>
                                            <div className="row">
                                                <FormFieldSelect
                                                    formUtility={formUtility}
                                                    options={windowUtility.limitModes}
                                                    field="limitMode"
                                                    label="Limit Mode"
                                                    description="Limit mode for this group."
                                                    className="col-md-4" />
                                                <FormFieldNumber
                                                    formUtility={formUtility}
                                                    integerOnly={true}
                                                    field="limit"
                                                    label="Limit"
                                                    description="Maximum number of rates shown based on the selected rate mode and from the current or selected date.  If zero is set then there is no limit."
                                                    className="col-md-4" />
                                                <FormFieldNumber
                                                    formUtility={formUtility}
                                                    integerOnly={true}
                                                    field="maxDays"
                                                    label="Max Days"
                                                    description="Maximum number of days in the future.  If zero is set then there is no limit.  E.g. A value of one means today only, a value of two means today and tomorrow only."
                                                    className="col-md-4" />
                                            </div>
                                        </div>
                                    : null
                                }
                                <div className="page-section">
                                    <h2>Date Attibutes</h2>
                                        <div className="row">
                                        <FormFieldText
                                            formUtility={formUtility}
                                            field="dateAttributes"
                                            label="Date Attributes"
                                            description="A comma seperated list of attribute names.  Enables you to read in a date from the addition details section of an order or under an item in the order."
                                            className="col-md-6" />
                                        <FormFieldNumber
                                            formUtility={formUtility}
                                            integerOnly={true}
                                            field="dateAttributeOffset"
                                            label="Date Attribute Offset"
                                            description="Offsets the date from the date attribute by the specified number of hours."
                                            className="col-md-6" />
                                    </div>
                                </div>
                            </>
                    }
                </div>
    );
}